export default "__VITE_ASSET__DgI0j5xR__"